import React, { FC, useState } from 'react';
import { Input, Button, Card, Typography, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';

import { Form } from '~/components';
import { setPassword } from '~/api/onboarding';
import { passwordMinLength } from '../../login';
import { useLogin } from '~/hooks/auth';
import { useInvitationPageState } from '~/hooks/invitation';
import { useIdentity } from '~/hooks/identity';

const { Title, Text } = Typography;

const SetPassword: FC = () => {
  const apiIdentityQuery = useIdentity();
  const [pageState, { setPasswordSuccess }] = useInvitationPageState();
  const email = pageState.data?.emailAddress;
  const businessName = pageState.data?.businessLegalName;

  const [isLoading, setLoading] = useState(false);

  const loginController = useLogin();

  const onFinish = async (values: any) => {
    const { password, confirmPassword } = values;
    setLoading(true);
    if (password === confirmPassword) {
      try {
        await setPassword(password);
        if (email) {
          try {
            await apiIdentityQuery.refetch();
            await loginController.login(email, password);
          } catch (error) {}
        }
        setPasswordSuccess(password);
      } catch (e) {
        void message.error('Failed to set password!', 10);
      }
    }
    setLoading(false);
  };

  const { t } = useTranslation('invitation');

  const [form] = Form.useForm();

  return (
    <Card className="Invitation-Card">
      <Title className="Invitation-Title" level={2}>
        {t('translation:businessPortal').toUpperCase()}
      </Title>
      <Text type="secondary" className="Invitation-TextSignIn">
        <Trans
          ns="invitation"
          defaults="invitationMessage"
          values={{
            businessName,
            email,
          }}
        />
      </Text>

      <Form form={form} layout="vertical" size="large" onFinish={onFinish}>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              min: passwordMinLength,
            },
          ]}
        >
          <Input.Password placeholder={t('translation:password')} prefix={<LockOutlined />} />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          rules={[
            {
              required: true,
            },
            ({ getFieldValue }: any) =>
              ({
                validator(rule: string, value: any) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }

                  // eslint-disable-next-line prefer-promise-reject-errors
                  return Promise.reject(t('translation:passwordsNotMatch'));
                },
              } as any),
          ]}
        >
          <Input.Password
            placeholder={t('translation:confirmPassword')}
            prefix={<LockOutlined />}
          />
        </Form.Item>
        <Form.Item noStyle>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            {t('Set password')}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default SetPassword;
